<osp-button
  [category]="'ghost'"
  [rounded]="true"
  (onClick)="onClick.emit()"
  [tooltip]="$tooltip()"
  [disabled]="$disabled()"
>
  <osp-icon [icon]="IconKey.TopbarNotificationAcknowledge | icon" [iconSize]="'large'"></osp-icon>
</osp-button>
